// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .custom-date-range-picker .MuiFormControl-root  {
    min-width: 148px !important;
    height: 40px;
  },
  .custom-date-range-picker .MuiOutlinedInput-root {
    border-color: transparent;
  }
   .custom-date-range-picker .MuiInputBase-root  {
    background: #FFF;
  }
  .custom-date-range-picker .MuiInputBase-root:hover  {
    border: none !important;
  }
  .custom-date-range-picker .MuiStack-root   {
    padding-top: 0px;
  }
  .custom-date-range-picker .MuiInputBase-input {
    font-size: 12px;
    font-weight:600;
    font-family: 'Poppins', sans-serif !important;
  }
  .rsm-svg  {
    width: 100%;
    height: 600px;
  }
  .rsm-geographies {
    fill: rgba(204, 222, 255, 1); 
  }
  .rsm-geography {
    fill: #E7E9F5;
    stroke-width: 0.25px;
    stroke: #BEBBBB;
    backdrop-filter: blur(2px);
  }
  .rsm-geographies .rsm-geography  {
    fill: #E7E9F5;
    stroke: #BEBBBB;
  }
  .legend {
    display: flex;
    flex-direction: column;
    padding: 20px;
  }
  .legend-item {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    justify-content: end;
  }
  .legend-color {
    width: 20px;
    height: 20px;
    margin-right: 5px;
    border: 2px solid #F3AAAD;
    border-radius: 50%;
  }
  .legend-label {
    font-size: 12px;
  }
  @keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 0.25; }
    100% { opacity: 1; }
  }
  
  .blinking-icon {
    
  }
  .notification{
    width: 40px; 
    height: 40px;
    position: absolute;
    border-radius: 50px;
    background: #E01F29;
    border: 3px solid #F3AAAD;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    animation: blink 1s infinite;
    top:60vh;
    right: 4%;
  }
  .cross{
    width: 40px; 
    height: 40px;
    border-radius: 50px;
    background: #FFFFFFCC;
    border: 4px solid #80808026;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    top: 60vh;
    right: 4%;
  }

.control-dots{
  display: none;
}
.carousel.carousel-slider .control-arrow {
background-color: #FFFFFF!important; 
}
.carousel .slider-wrapper {
margin: 0px 50px !important;
}
.carousel .control-prev.control-arrow:before {
border-right: 8px solid rgb(95, 95, 95) !important;
}
.carousel .control-next.control-arrow:before {
border-left: 8px solid rgb(95, 95, 95) !important;
}
.MuiTabScrollButton-root {
display: none !important;
}

.donut-container {
  position: relative;
  width: 100px;
  height: 60px;
}
.alert-container{
  position: relative;
  width: 60px;
  height: 60px;
}
.donut {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 7px solid #ECE1B9; 
  border-radius: 50%;
  clip-path: circle(50% at center);
}
.donutError{
  position: absolute;
  width: 100%;
  height: 100%;
  border: 7px solid #EDD3D5; 
  border-radius: 50%;
  clip-path: circle(50% at center);
}

.donut::after,.donutError::after {
  content: attr(data-text);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #333333; 
  font-family: 'Poppins', sans-serif !important; 
  font-size: 12px; 
  font-weight: 600; 
}
.alert .MuiAlert-message{
  display: flex;
  width: 100% !important;
}
#customized-dialog-title{
  display: flex;
  align-items: center;
}
.donut-container {
  position: relative;
  width: 100px;
  height: 60px;
}
.alert-container{
  position: relative;
  width: 60px;
  height: 60px;
}
.donut {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 7px solid #ECE1B9; 
  border-radius: 50%;
  clip-path: circle(50% at center);
}
.donutError{
  position: absolute;
  width: 100%;
  height: 100%;
  border: 7px solid #EDD3D5; 
  border-radius: 50%;
  clip-path: circle(50% at center);
}

.donut::after,.donutError::after {
  content: attr(data-text);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #333333; 
  font-family: 'Poppins', sans-serif !important; 
  font-size: 12px; 
  font-weight: 600; 
}
.alert .MuiAlert-message{
  display: flex;
  width: 100% !important;
  justify-content: space-between;
  align-items: center;
}
#customized-dialog-title{
  display: flex;
  align-items: center;
}
.scroll-container {
  width: 100%;
  overflow-x: auto; 
  white-space: nowrap; 
  padding: 20px 0;
}

.scroll-content {
  display: inline-block; 
}
.item {
  display: inline-block;
  min-width: 200px; 
  height: 200px; 
  margin-right: 10px; 
  vertical-align: top; 
}
.vertical-line {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px; 
  position: relative;
}
.line {
  position: absolute;
  top: 0;
  left: 50%;
  width: 1px; 
  height: 100%; 
  background-color: #9294974d; 
  transform: translateX(-50%);
}
.or-text {
  background-color: #fff; 
  padding: 0 10px;
  font-size: 10px;
  font-weight: bold;
  color: #9294974d;
  z-index: 1; 
}
.dotted-box {
  width: 300px;
  border: 2px dotted #aaa; 
  display: flex;
  flex-direction: column;
  align-items: center ;
  padding: 30px; 
  text-align: center; 
  margin-top: 20px;
  line-height: 100px; 
}




  
`, "",{"version":3,"sources":["webpack://./src/common/styles.css"],"names":[],"mappings":"CAAC;IACG,2BAA2B;IAC3B,YAAY;EACd,CAAC;;IAEC,yBAAyB;EAC3B;GACC;IACC,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,eAAe;IACf,6CAA6C;EAC/C;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,aAAa;IACb,oBAAoB;IACpB,eAAe;IACf,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,KAAK,UAAU,EAAE;IACjB,MAAM,aAAa,EAAE;IACrB,OAAO,UAAU,EAAE;EACrB;;EAEA;;EAEA;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,4BAA4B;IAC5B,QAAQ;IACR,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,SAAS;EACX;;AAEF;EACE,aAAa;AACf;AACA;AACA,mCAAmC;AACnC;AACA;AACA,2BAA2B;AAC3B;AACA;AACA,kDAAkD;AAClD;AACA;AACA,iDAAiD;AACjD;AACA;AACA,wBAAwB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[" .custom-date-range-picker .MuiFormControl-root  {\n    min-width: 148px !important;\n    height: 40px;\n  },\n  .custom-date-range-picker .MuiOutlinedInput-root {\n    border-color: transparent;\n  }\n   .custom-date-range-picker .MuiInputBase-root  {\n    background: #FFF;\n  }\n  .custom-date-range-picker .MuiInputBase-root:hover  {\n    border: none !important;\n  }\n  .custom-date-range-picker .MuiStack-root   {\n    padding-top: 0px;\n  }\n  .custom-date-range-picker .MuiInputBase-input {\n    font-size: 12px;\n    font-weight:600;\n    font-family: 'Poppins', sans-serif !important;\n  }\n  .rsm-svg  {\n    width: 100%;\n    height: 600px;\n  }\n  .rsm-geographies {\n    fill: rgba(204, 222, 255, 1); \n  }\n  .rsm-geography {\n    fill: #E7E9F5;\n    stroke-width: 0.25px;\n    stroke: #BEBBBB;\n    backdrop-filter: blur(2px);\n  }\n  .rsm-geographies .rsm-geography  {\n    fill: #E7E9F5;\n    stroke: #BEBBBB;\n  }\n  .legend {\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n  }\n  .legend-item {\n    display: flex;\n    align-items: center;\n    margin-bottom: 5px;\n    justify-content: end;\n  }\n  .legend-color {\n    width: 20px;\n    height: 20px;\n    margin-right: 5px;\n    border: 2px solid #F3AAAD;\n    border-radius: 50%;\n  }\n  .legend-label {\n    font-size: 12px;\n  }\n  @keyframes blink {\n    0% { opacity: 1; }\n    50% { opacity: 0.25; }\n    100% { opacity: 1; }\n  }\n  \n  .blinking-icon {\n    \n  }\n  .notification{\n    width: 40px; \n    height: 40px;\n    position: absolute;\n    border-radius: 50px;\n    background: #E01F29;\n    border: 3px solid #F3AAAD;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    animation: blink 1s infinite;\n    top:60vh;\n    right: 4%;\n  }\n  .cross{\n    width: 40px; \n    height: 40px;\n    border-radius: 50px;\n    background: #FFFFFFCC;\n    border: 4px solid #80808026;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    position: absolute;\n    top: 60vh;\n    right: 4%;\n  }\n\n.control-dots{\n  display: none;\n}\n.carousel.carousel-slider .control-arrow {\nbackground-color: #FFFFFF!important; \n}\n.carousel .slider-wrapper {\nmargin: 0px 50px !important;\n}\n.carousel .control-prev.control-arrow:before {\nborder-right: 8px solid rgb(95, 95, 95) !important;\n}\n.carousel .control-next.control-arrow:before {\nborder-left: 8px solid rgb(95, 95, 95) !important;\n}\n.MuiTabScrollButton-root {\ndisplay: none !important;\n}\n\n.donut-container {\n  position: relative;\n  width: 100px;\n  height: 60px;\n}\n.alert-container{\n  position: relative;\n  width: 60px;\n  height: 60px;\n}\n.donut {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border: 7px solid #ECE1B9; \n  border-radius: 50%;\n  clip-path: circle(50% at center);\n}\n.donutError{\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border: 7px solid #EDD3D5; \n  border-radius: 50%;\n  clip-path: circle(50% at center);\n}\n\n.donut::after,.donutError::after {\n  content: attr(data-text);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #333333; \n  font-family: 'Poppins', sans-serif !important; \n  font-size: 12px; \n  font-weight: 600; \n}\n.alert .MuiAlert-message{\n  display: flex;\n  width: 100% !important;\n}\n#customized-dialog-title{\n  display: flex;\n  align-items: center;\n}\n.donut-container {\n  position: relative;\n  width: 100px;\n  height: 60px;\n}\n.alert-container{\n  position: relative;\n  width: 60px;\n  height: 60px;\n}\n.donut {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border: 7px solid #ECE1B9; \n  border-radius: 50%;\n  clip-path: circle(50% at center);\n}\n.donutError{\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border: 7px solid #EDD3D5; \n  border-radius: 50%;\n  clip-path: circle(50% at center);\n}\n\n.donut::after,.donutError::after {\n  content: attr(data-text);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #333333; \n  font-family: 'Poppins', sans-serif !important; \n  font-size: 12px; \n  font-weight: 600; \n}\n.alert .MuiAlert-message{\n  display: flex;\n  width: 100% !important;\n  justify-content: space-between;\n  align-items: center;\n}\n#customized-dialog-title{\n  display: flex;\n  align-items: center;\n}\n.scroll-container {\n  width: 100%;\n  overflow-x: auto; \n  white-space: nowrap; \n  padding: 20px 0;\n}\n\n.scroll-content {\n  display: inline-block; \n}\n.item {\n  display: inline-block;\n  min-width: 200px; \n  height: 200px; \n  margin-right: 10px; \n  vertical-align: top; \n}\n.vertical-line {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 300px; \n  position: relative;\n}\n.line {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  width: 1px; \n  height: 100%; \n  background-color: #9294974d; \n  transform: translateX(-50%);\n}\n.or-text {\n  background-color: #fff; \n  padding: 0 10px;\n  font-size: 10px;\n  font-weight: bold;\n  color: #9294974d;\n  z-index: 1; \n}\n.dotted-box {\n  width: 300px;\n  border: 2px dotted #aaa; \n  display: flex;\n  flex-direction: column;\n  align-items: center ;\n  padding: 30px; \n  text-align: center; \n  margin-top: 20px;\n  line-height: 100px; \n}\n\n\n\n\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
